const prefix = ''

export const alertUrls = {
  'alert.list': `${prefix}/alerts`,
  'alert.view': (id = ':alertId') => `${prefix}/alerts/${id}`,
}
